import { useEffect, useRef, useState } from 'react'

export function useStableLoadedData<T>(data: T, isLoading: boolean): { data: T; hasLoaded: boolean } {
  const [hasLoaded, setHasLoaded] = useState(false)
  const [stableData, setStableData] = useState(data)
  const wasLoadingRef = useRef(true)

  useEffect(() => {
    const finishedLoading = wasLoadingRef.current && !isLoading
    wasLoadingRef.current = isLoading
    if (isLoading || (hasLoaded && !finishedLoading)) return
    setStableData(data)
    setHasLoaded(true)
  }, [data, hasLoaded, isLoading])

  return {
    data: isLoading && hasLoaded ? stableData : data,
    hasLoaded,
  }
}
